'use strict';

define('slider',[
  'jquery',
  'responsive-backgrounds',
  'jquery-hoverIntent'
], function ($, RespBgs) {

  var $slider           = $('.slider'),
      $slides           = $slider.find('.slide'),
      $slide_headers    = $slider.find('.slide__content-header'),
      $slide_list_item  = $slider.find('.slide__list-item'),
      slides_number     = $slides.length,
      $hero_headers     = $('.hero__content-header'),
      current_index     = 0,
      interval_id       = 0,
      interval          = 4500,
      is_rotating       = false;

  var IS_ACTIVE     = 'is-active';

  var hasVideo = document.getElementById('slide-iframe') ? true : false;

  var handlers = {
    slideListItemHover: function() {
      autorotate.stop();
      current_index = $(this).index();
      showNextSlide();
    },

    slideListItemHoverOut: function() {
      autorotate.start();
    }
  };

  var autorotate = {
    start: function(delay_msec) {
      is_rotating = true;
      delay_msec  = delay_msec || 0;

      setTimeout(function(){
        interval_id = setInterval(showNextSlide, interval);
      }, delay_msec);
    },

    stop: function() {
      is_rotating = false;
      clearInterval(interval_id);
    }
  };

  var initSlider = function() {

    new RespBgs({
      global_holder_selector: '.slider',
      image_box_selector: '.slide'
    });

    if(hasVideo === false) {
      attachEvents();
    }

    checkHeaders();
    showNextSlide();

    if(hasVideo === false) {
      autorotate.start();
    }
  };

  var attachEvents = function() {
    $slide_list_item.hoverIntent(handlers.slideListItemHover, handlers.slideListItemHoverOut);
  };

  var checkHeaders = function() {
    $slide_headers.add($hero_headers).each(function(index){
      if ( $(this).text().trim() === '' ) {
        $(this).remove();
      }
    });
  };

  var showNextSlide = function() {
    $slides.filter('.' + IS_ACTIVE).removeClass(IS_ACTIVE);
    $slides.eq(current_index).addClass(IS_ACTIVE);
    if(hasVideo === false) {
      showRelevantContentBox();
    }

    current_index++;
    if(slides_number === current_index) {
      current_index = 0;
    }
  };

  var showRelevantContentBox = function() {
    $slide_list_item.filter('.' + IS_ACTIVE).removeClass(IS_ACTIVE);
    $slide_list_item.eq(current_index).addClass(IS_ACTIVE);
  };

  return {
    init: initSlider,
    start: autorotate.start,
    stop: autorotate.stop
  };
});
